import { NavigateWithParams } from '@spacefill/shared/src/utils/RouterUtils';

import { getRuleViewPath } from '../../pages/automations/AutomaticDataCompletion/constants';

const AutomationList = async () =>
    import('../../pages/automations/List').then((module) => ({
        Component: module.AutomationList,
    }));
const OrderRouting = async () =>
    import('../../pages/automations/OrderRouting/OrderRouting').then((module) => ({
        Component: module.OrderRouting,
    }));
const OrderSyncConditions = async () =>
    import('../../pages/automations/OrderSyncConditions/OrderSyncConditions').then((module) => ({
        Component: module.OrderSyncConditions,
    }));
const StockAlerts = async () =>
    import('../../pages/automations/StockAlerts/StockAlerts').then((module) => ({
        Component: module.StockAlerts,
    }));
const AutomaticDataCompletionRulesList = async () =>
    import('../../pages/automations/AutomaticDataCompletion/RulesList').then((module) => ({
        Component: module.RulesList,
    }));
const AutomaticDataCompletionNewRule = async () =>
    import('../../pages/automations/AutomaticDataCompletion/NewRule').then((module) => ({
        Component: module.NewRule,
    }));
const AutomaticDataCompletionEditRule = async () =>
    import('../../pages/automations/AutomaticDataCompletion/EditRule').then((module) => ({
        Component: module.EditRule,
    }));
const TransportPricing = async () =>
    import('../../pages/automations/TransportPricing/List').then((module) => ({
        Component: module.List,
    }));
const TransportPricingNew = async () =>
    import('../../pages/automations/TransportPricing/New').then((module) => ({
        Component: module.TransportPricingNew,
    }));
const TransportPricingEdit = async () =>
    import('../../pages/automations/TransportPricing/Edit').then((module) => ({
        Component: module.TransportPricingEdit,
    }));

const getAutomationRoutes = (user, features) => {
    if (user?.carrierId) return [];

    return [
        {
            path: '/automations/',
            lazy: AutomationList,
        },
        {
            path: '/automations/order-routing',
            lazy: OrderRouting,
        },
        {
            path: '/automations/order-sync-conditions',
            lazy: OrderSyncConditions,
            condition: user.features?.automations?.orderIntegrationConditionsEnabled,
        },
        {
            path: '/automations/stock-alerts',
            lazy: StockAlerts,
        },
        {
            path: '/automations/automatic-data-completion/',
            lazy: AutomaticDataCompletionRulesList,
            redirectFrom: ['/automations/automatic-data-completion'],
        },
        {
            path: '/automations/automatic-data-completion/new/',
            lazy: AutomaticDataCompletionNewRule,
            condition: Boolean(user?.isAppAdmin),
            conditionFailedRedirect: '/automations/automatic-data-completion/',
            redirectFrom: ['/automations/automatic-data-completion/new'],
        },
        {
            path: '/automations/automatic-data-completion/:ruleId/',
            element: (
                <NavigateWithParams
                    to={(params) => getRuleViewPath(params.ruleId)}
                    replace
                />
            ),
            redirectFrom: ['/automations/automatic-data-completion/:ruleId'],
        },
        {
            path: '/automations/automatic-data-completion/:ruleId/edit/',
            lazy: AutomaticDataCompletionEditRule,
            condition: Boolean(user?.isAppAdmin),
            conditionFailedRedirect: '/automations/automatic-data-completion/',
            redirectFrom: ['/automations/automatic-data-completion/:ruleId/edit'],
        },
        {
            path: '/automations/transport-costs',
            lazy: TransportPricing,
            condition: features?.transport_pricing_enabled,
        },
        {
            path: '/automations/transport-costs/new',
            lazy: TransportPricingNew,
            condition: features?.transport_pricing_enabled && Boolean(user?.isAppAdmin),
            conditionFailedRedirect: '/automations/transport-costs',
        },
        {
            path: '/automations/transport-costs/:gridId/edit',
            lazy: TransportPricingEdit,
            condition: features?.transport_pricing_enabled && Boolean(user?.isAppAdmin),
            conditionFailedRedirect: '/automations/transport-costs',
        },
        {
            path: '/automations/transport-costs/:gridId',
            element: (
                <NavigateWithParams
                    to={(params) => `/automations/transport-costs?gridId=${params.gridId}`}
                    replace
                />
            ),
            condition: features?.transport_pricing_enabled,
        },
    ];
};

export { getAutomationRoutes };
